import { useParams } from "react-router-dom";
import {isDefined} from "../../../../../util/is-type";
import {stringToInt} from "../../../../../util/number-util";

export interface ISongDetailsRouterParamsLogic {
  songId: number;
  lessonId?: number;
}

export const useSongDetailsRouterParams = (): ISongDetailsRouterParamsLogic => {
  const routerParams = useParams<{ songId: string, lessonId?: string }>();
  const songId = stringToInt(routerParams.songId ?? '');

  const lessonId = isDefined(routerParams.lessonId) ?
    stringToInt(routerParams.lessonId) :
    undefined;

  return {
    songId,
    lessonId,
  };
};
